export default {
  title: 'Estatísticas',
  ekrmTab: 'EKRM',
  referenceModelsTab: 'Modelos de Referência',
  export: 'Exportar',
  headerModel: 'Modelo',
  headerDateCreated: 'Data de Criação',
  headerCreatedBy: 'Criado Por',
  headerReference: 'Referência',
  headerCountry: 'País',
  headerReferenceId: 'ID de Referência',
  headerCategory: 'Categoria',
  headerCustomModelsCount: 'Quantidade de Modelos Personalizados',
  headerCountLast90Days: 'Quantidade Últimos 90 dias'
}
